module.exports = __webpack_public_path__ + "static/media/boardingPass.3b02fbae.svg";